// hooks/useExport.js
import { useState } from 'react';
import CoreHttpHandler from 'http/services/CoreHttpHandler';
import { exportToExcel } from 'app/utility/ExportToExcelUtility';

const useExport = () => {
    const [isExporting, setIsExporting] = useState(false);

    const handleExport = ({
        module,
        method,
        payload,
        fileNamePrefix,
        sheetName,
        columns,
        dateRange,
        getDataFromResponse,
        onSuccess,
        onError
    }) => {
        setIsExporting(true);

        CoreHttpHandler.request(
            module,
            method,
            payload,
            response => {
                setIsExporting(false);

                const data = getDataFromResponse
                    ? getDataFromResponse(response)
                    : response.data?.data || [];

                if (!data || data.length === 0) {
                    onError?.('No data to export');
                    return;
                }

                const result = exportToExcel({
                    fileNamePrefix,
                    dateRange,
                    sheets: [{ name: sheetName, data, columns }]
                });

                if (result.success) {
                    onSuccess?.(result.fileName);
                } else {
                    onError?.(result.error);
                }
            },
            error => {
                setIsExporting(false);
                onError?.(error.response?.data?.message || 'Export failed');
            }
        );
    };

    return { isExporting, handleExport };
};

export default useExport;